import { render, staticRenderFns } from "./ReferenceNew.vue?vue&type=template&id=75b98e26&"
import script from "./ReferenceNew.vue?vue&type=script&lang=js&"
export * from "./ReferenceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports